// Firebase configuration file
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Your Firebase config from the Firebase console
// Replace these with your actual Firebase project config
const firebaseConfig = {
  apiKey: "AIzaSyAYNRwPAwIkojoPvpH8k4gMH5Rb2cz9wyk",
  authDomain: "itemizationapp.firebaseapp.com",
  databaseURL: "https://itemizationapp-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "itemizationapp",
  storageBucket: "itemizationapp.firebasestorage.app",
  messagingSenderId: "789359621983",
  appId: "1:789359621983:web:f1fb6d1411f87fb6a568ea",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getDatabase(app);
export const database = db;

export default app; 